export const GUEST_LIMIT_MS = 60 * 60 * 1000;
export const GUEST_USAGE_KEY = "jiggly_guest_used_ms";
let memoryUsage = 0;

export const readGuestUsage = () => {
  try {
    const saved = Number(localStorage.getItem(GUEST_USAGE_KEY));
    memoryUsage = Math.max(memoryUsage, Number.isFinite(saved) && saved >= 0 ? saved : 0);
  } catch { /* Private/storage-restricted browsers retain this visit's usage in memory. */ }
  return Math.min(GUEST_LIMIT_MS, memoryUsage);
};

export const recordGuestUsage = (milliseconds) => {
  memoryUsage = Math.min(GUEST_LIMIT_MS, readGuestUsage() + Math.max(0, milliseconds));
  try { localStorage.setItem(GUEST_USAGE_KEY, String(memoryUsage)); } catch { /* In-memory budget still applies. */ }
  return memoryUsage;
};